
import React from 'react';
import { getOptOutReceivedLength } from '@/utils/smsUtils';

interface MessageCharacterCountProps {
  characterCount: number;
  smsSegments: number;
  maxLength: number;
}

const MessageCharacterCount: React.FC<MessageCharacterCountProps> = ({
  characterCount,
  smsSegments,
  maxLength
}) => {
  // For calculating display values - use RECEIVED length that customers see
  // Kudosity system: We send 20 chars ([unsub-reply-link]), customers receive 22 chars (link)
  const optOutLength = getOptOutReceivedLength(); // 22 characters received
  const totalCount = characterCount + optOutLength;
  
  // Generate character count text and styling
  const getCharacterCountClass = () => {
    if (totalCount > maxLength) {
      return "text-amber-500";  // Warning color when over 1 SMS
    }
    if (totalCount > maxLength * 2) {
      return "text-red-500";    // Alert color when over 2 SMS
    }
    return "text-muted-foreground";
  };

  return (
    <div className="flex justify-between items-center mt-1">
      <p className={`text-sm ${getCharacterCountClass()}`}>
        {characterCount} characters + {optOutLength} (opt-out message) = {totalCount} total
        {smsSegments > 1 ? ` (${smsSegments} messages)` : ''}
      </p>
      <p className="text-xs text-muted-foreground">
        {smsSegments > 1 
          ? `Messages longer than ${maxLength} chars will be split` 
          : 'Includes opt-out link'}
      </p>
    </div>
  );
};

export default MessageCharacterCount;
